module.exports = __webpack_public_path__ + "img/avatar-10.73c144be.png";